import api from './api'
import { toast } from 'react-toastify'

export function linkMedicoToRepresentante(farmaciaId, medicoId, representanteId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.post(`/farmacias/${farmaciaId}/usuarios/${medicoId}/representantes/${representanteId}`, {}, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao vincular médico ao representante");
      return reject(e);
    }
  })
}

export function unlinkMedicoToRepresentante(farmaciaId, medicoId, representanteId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`/farmacias/${farmaciaId}/usuarios/${medicoId}/representantes/${representanteId}`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao remover vínculo médico ao representante");
      return reject(e);
    }
  })
}

export function findAllLinksRepresentante(farmaciaId, representanteId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`/farmacias/${farmaciaId}/representantes/${representanteId}/medicos`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Falha ao buscar vinculos entre representante e médico");
      return reject(e);
    }
  })
}
